export {
    getCategories,
    getTopCategories,
    getSubCategories,
    getSubCategoriesFromCategory,
    getCategoryTitle,
    getCategoryTitleFromState
} from './categories';

export {getPickerColor} from './colorpicker';

export {
    getPattern,
    getPatterns,
    getPatternInitialColors,
    getPatternThumbnails,
    getPatternColors,
    getSwatchColor,
    isColorable,
    getPatternTitle
} from './patterns';

export {getCurrentPatternId, getCurrentPatternThumbnailUri} from './currentPattern';

export {getUriLangCode, getCurrentLangCode, getMessage} from './i18n';

export {
    getBreakpoint,
    getWindowHeight,
    getWindowWidth,
    getBreakpointMaxWidth
} from './breakpoint'

export {
    getPatternsCountToRender,
    getGalleryThumbnailType,
    getAppBarType
} from './ui.patterngallery';

export {getActiveFabric, getActiveFabricId} from './fabrics'
export {getPriceScales, getFabricPrice, getBasePrice} from './prices'



// WEBPACK FOOTER //
// ./src/reducers/selectors.js